import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Text } from '@mantine/core';

function DefaultNode({ data, selected }: NodeProps) {
  const nodeType = data.type || 'Node';
  const color = data.color || '#6b7280';

  return (
    <Box
      style={{
        background: color,
        border: `2px solid ${selected ? '#374151' : 'transparent'}`,
        borderRadius: '6px',
        padding: '8px 12px',
        minWidth: '120px',
        color: 'white',
        boxShadow: selected ? '0 4px 12px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Handle type="target" position={Position.Top} />
      <Text size="xs" fw={600} lineClamp={1}>
        {nodeType}
      </Text>
      {data.label && (
        <Text size="xs" mt={2} opacity={0.9} lineClamp={1}>
          {data.label}
        </Text>
      )}
      <Handle type="source" position={Position.Bottom} />
    </Box>
  );
}

export default memo(DefaultNode);
